// Intent: [Branding] [Conversion]
import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { PORTAL_REGISTER_URL } from "../../config";
function AnnouncementBar() {
  return <div className="bg-pfpc-navy text-pfpc-offwhite" data-id="element-50" data-mp="1j366lagcd3xp">
      <div className="container-shell flex min-h-9 items-center justify-between gap-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] sm:text-xs" data-id="element-51" data-mp="1j3pl0h6s9a6z">
        <p data-id="element-52" data-mp="rci3vtz0rqhx">Plan. Price. Order. Online.</p>
        <a href={PORTAL_REGISTER_URL} data-analytics="start_design_clicked" className="inline-flex min-h-6 items-center gap-1 border-b border-pfpc-orange text-pfpc-offwhite transition hover:text-pfpc-orange focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pfpc-orange" data-id="element-53" data-mp="rdkus1wcdsxu">
          Start designing <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-54" data-mp="2brtr33t9npa7" />
        </a>
      </div>
    </div>;
}
export { AnnouncementBar };